import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import { login } from "../lib/api";
import { ADMIN } from "../constants/testIds";
import { Lock, AlertCircle } from "lucide-react";

const AdminLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(username, password);
      navigate("/admin");
    } catch (e) {
      setErr(e.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="max-w-md mx-auto px-6 py-24">
        <div className="font-mono-label text-[var(--slate)] mb-4 flex items-center gap-2"><Lock size={12} /> Admin</div>
        <h1 className="font-display text-4xl md:text-5xl text-[var(--ivory)] mb-10">Research desk access.</h1>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="font-mono-label text-[var(--slate)] mb-2 block">Username</label>
            <input
              className="input-field"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              data-testid={ADMIN.loginUsername}
            />
          </div>
          <div>
            <label className="font-mono-label text-[var(--slate)] mb-2 block">Password</label>
            <input
              type="password"
              className="input-field"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid={ADMIN.loginPassword}
            />
          </div>
          {err && (
            <div className="text-sm text-red-300 flex items-center gap-2">
              <AlertCircle size={14} /> {err}
            </div>
          )}
          <button type="submit" disabled={loading} className="btn-primary" data-testid={ADMIN.loginSubmit}>
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </Layout>
  );
};

export default AdminLogin;
